import React from "react";
import UseTable from "../../components-react/UseTable";

function OtherMemberships({ clickedRowValue }) {
  const columns = [
    {
      Header: "Subscription Type",
      accessor: "type",
      Cell: ({ value }) => {
        return (
          <span
            className="tdBolder borderRadius"
            style={{
              backgroundColor:
                value === "addon_pt"
                  ? "#8414AB"
                  : value === "nutrition"
                  ? "#D29700"
                  : "#3D6FD2",
              color: "#FFFFFF",
            }}
          >
            {value?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      Header: "Total Revenue",
      accessor: "gross_revenue",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "Online",
      accessor: "online",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "Cash",
      accessor: "cash",
      Cell: ({ value }) => {
        return <span className="tdBolder">{value || "0"}</span>;
      },
    },
    {
      Header: "Pre GST",
      accessor: "pre_GST_amount",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "GST",
      accessor: "gst",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "Net Revenue(Pre GST - Bank Charges)",
      accessor: "net_revenue",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "WTF Share(%)",
      accessor: "wtf_share_per",
      Cell: ({ value }) => {
        return <span className="tdNormal">{value || "0"}</span>;
      },
    },
    {
      Header: "Total Share WTF",
      accessor: "total_share_wtf",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "Total Share GYM",
      accessor: "total_share_gym",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "GST On WTF Facilities",
      accessor: "gst_on_wtf_share",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
    {
      Header: "Bill Raised to GYM",
      accessor: "bill_raised_gym",
      Cell: ({ value }) => {
        return <span className="tdNormal">₹{value || "0"}</span>;
      },
    },
  ];

  return (
    <>
      <UseTable
        columns={columns || [{}]}
        data={clickedRowValue?.share_details || []}
        footerValues={clickedRowValue}
        name="other-membership"
      />
    </>
  );
}

export default OtherMemberships;
